var map = {
	"./armani-exchange.jpg": 4331,
	"./boss.jpg": 3034,
	"./calvin-klein-jeans.jpg": 9300,
	"./calvin-klein-underwear.jpg": 1166,
	"./carpisa.jpg": 6542,
	"./emporio-armani.jpg": 9999,
	"./gant.jpg": 503,
	"./geox.jpg": 2312,
	"./guess-accessories.jpg": 5991,
	"./guess-jeans.jpg": 5480,
	"./guess.jpg": 2006,
	"./hugo.jpg": 7342,
	"./parfois.jpg": 3245,
	"./plein-sport.jpg": 1044,
	"./replay.jpg": 3228,
	"./springfield.jpg": 9931,
	"./stillium.jpg": 7920,
	"./timberland.jpg": 1811,
	"./tom-taylor.jpg": 1477,
	"./tommy-hilfiger.jpg": 1092,
	"./women-secret.jpg": 6702,
	"./xyz.jpg": 7580
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3118;